import script from "./ESportsLiveFixtureBook.vue?vue&type=script&setup=true&lang=js"
export * from "./ESportsLiveFixtureBook.vue?vue&type=script&setup=true&lang=js"

import "./ESportsLiveFixtureBook.vue?vue&type=style&index=0&id=18630d44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18630d44"]])

export default __exports__